module.exports = __webpack_public_path__ + "img/NCENA.53008cc8.png";